import { queryClient } from "@/lib/queryClient";
import { queryKeys } from "@/lib/queryKeys";

export function invalidateSiteContent() {
  return queryClient.invalidateQueries({ queryKey: queryKeys.settings });
}

export function invalidateHomeSections() {
  return queryClient.invalidateQueries({ queryKey: queryKeys.homeSections });
}

export function invalidateAbout() {
  return queryClient.invalidateQueries({ queryKey: queryKeys.about });
}

export function invalidateMemberCount() {
  return queryClient.invalidateQueries({ queryKey: queryKeys.memberCount });
}

export function invalidateUnitCount() {
  return queryClient.invalidateQueries({ queryKey: queryKeys.unitCount });
}

export function invalidateUnitAggregates() {
  return Promise.all([invalidateMemberCount(), invalidateUnitCount()]);
}

export function invalidateActiveForms() {
  return queryClient.invalidateQueries({ queryKey: queryKeys.activeForms });
}

export function invalidateAllPublicContent() {
  return Promise.all([
    queryClient.invalidateQueries({ queryKey: queryKeys.settings }),
    queryClient.invalidateQueries({ queryKey: queryKeys.homeSections }),
    queryClient.invalidateQueries({ queryKey: queryKeys.about }),
    queryClient.invalidateQueries({ queryKey: queryKeys.forums }),
    queryClient.invalidateQueries({ queryKey: queryKeys.events }),
    queryClient.invalidateQueries({ queryKey: queryKeys.units }),
    invalidateUnitAggregates(),
    queryClient.invalidateQueries({ queryKey: queryKeys.sponsors }),
    queryClient.invalidateQueries({ queryKey: ["banners"] }),
    queryClient.invalidateQueries({ queryKey: queryKeys.activeForms }),
  ]);
}
